import { createBrowserHistory } from "history";
export default createBrowserHistory(); 
// import createHistory from 'history/createBrowserHistory'
// export const history = createHistory()
// export default history